<div class="progress-box" *ngFor="let skills of data">
  <div class="progress-title">{{skills.title}}</div>
  <div class="progress">
     <div class="progress-bar wow slideInLeft" data-wow-duration="1s" data-wow-delay="0.5s" role="progressbar" style="width: {{skills.score}}%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</div>
